import axios from "axios";
import { apikey, apirouter } from "../../api/apirouter";
import apiurl from "../../api/apiurl";

export const actiontype = {
  POST_ACCEEPT_ORDER: "POST_ACCEEPT_ORDER",
  POST_WEIGHT: "POST_WEIGHT",
  GET_PRINTLABEL: "GET_PRINTLABEL",
  POST_PRINTLABEL: "POST_PRINTLABEL",
  SELECTED_LOCATION: "SELECTED_LOCATION",
  ENTER_LOCATION: "ENTER_LOCATION",
  POST_ORDERPRINTLABEL: "POST_ORDERPRINTLABEL",
  POST_WEIGHT_WIP: "POST_WEIGHT_WIP",
  POST_WEIGHT_MASTER: "POST_WEIGHT_MASTER",
  POST_CANCEL_ORDER: "POST_CANCEL_ORDER",
  CHANGE_METER: "CHANGE_METER",
};

// 🛠️ ฟังก์ชัน Helper สำหรับจัดการ Error และ HTTP Status
const handleApiError = (error: any) => {
  console.log("API Error Log:", error);

  if (error.response) {
    const status = error.response.status;
    const sapMessage = error.response.data?.message || error.response.data?.error || "";

    if (status === 400) return { success: false, message: `ข้อมูลไม่ถูกต้อง (Error 400): ${sapMessage}` };
    if (status === 403) return { success: false, message: "ไม่มีสิทธิ์เข้าถึงระบบ SAP (Error 403)" };
    if (status === 404) return { success: false, message: "ไม่พบปลายทาง API ของ SAP (Error 404)" };
    if (status === 500) return { success: false, message: `ระบบ SAP ขัดข้อง (Error 500): ${sapMessage}` };
    if (status === 503 || status === 504) return { success: false, message: "ระบบ SAP ไม่พร้อมใช้งานชั่วคราว (Error 503/504)" };

    return {
      success: false,
      message: sapMessage ? `SAP แจ้งข้อผิดพลาด (${status}): ${sapMessage}` : `เกิดข้อผิดพลาดจากเซิร์ฟเวอร์ (${status})`
    };
  }

  return {
    success: false,
    message: "ไม่สามารถเชื่อมต่ออินเทอร์เน็ตหรือเซิร์ฟเวอร์ได้"
  };
};

export const postAcceptOrder =
  (item: any, profile: any) => async (dispatch: any) => {
    try {
      const response = await apiurl.post(apirouter.acceptorder, {
        product_id: item?.product_id,
        reel_no: item?.reel_no,
        meter: item?.meter,
        empcode: profile?.EmpCode,
        weight_location: item?.weight_location,
        ncr_type: item?.ncr_type,
        container_id: item?.container_id,
        work_type: item?.type,
      });

      if (response.data.status === true) {
        dispatch({
          type: actiontype.POST_ACCEEPT_ORDER,
          payload: response.data.data,
        });
        return {
          success: true,
          data: response.data.data,
          message: response.data.message,
        };
      } else {
        return { success: false, message: response.data.message };
      }
    } catch (error: any) {
      return handleApiError(error);
    }
  };

export const postWeight =
  (
    scale: any,
    weight: any,
    profile: any,
    item: any,
    postwip: any,
    customer_reel: any,
    shift: string
  ) =>
  async (dispatch: any) => {
    try {
      const response = await apiurl.post(
        apirouter.weight, 
        {
          product_id: scale?.product_id, 
          reel_no: scale?.reel_no, 
          empcode: profile?.EmpCode, 
          weight: weight ? weight : "0", 
          weight_location: scale?.weight_location, 
          forklift: "0",
          item_type: item?.type,
          qrcode: postwip?.qrcode ? postwip?.qrcode : "",
          reel_customer: customer_reel ? customer_reel : "",
          shift: shift,
        },
        { timeout: 3600000 } // ⚠️ ถือสายรอนานสูงสุด 60 นาที
      );

      if (response.data.status === true) {
        dispatch({
          type: actiontype.POST_WEIGHT,
          payload: response.data.data,
        });
        return {
          success: true,
          data: response.data.data,
          message: response.data.data?.materialdoc?.message || response.data.message,
        };
      } else {
        return {
          success: false,
          message: response.data.data?.materialdoc?.message || response.data.message || "บันทึกข้อมูลเข้า SAP ไม่สำเร็จ",
        };
      }
    } catch (error: any) {
      console.log("⚠️ สายการเชื่อมต่อหลุดระหว่างรอ SAP (101/261)... กำลังยิงเช็คข้อมูลหลังบ้านย้อนหลัง", error);

      // 🌟 1. หน่วงเวลา 3 วินาที รอให้ Backend/SAP เขียนเอกสาร 101/261 ลง DB สมบูรณ์
      await new Promise((resolve) => setTimeout(resolve, 3000));

      try {
        // 🌟 2. ดึงข้อมูล Print Label ล่าสุดของ Product นี้
        const checkRes = await apiurl.get(`${apirouter.printlabel}${scale?.product_id}`);
        const latestData = checkRes.data?.data;

        const targetReel = scale?.reel_no || item?.reel_no;
        const fetchedReel = latestData?.reel_no || latestData?.materialdoc?.reel_no;

        // 🌟 3. ถ้าเจอข้อมูลและ Reel No ตรงกัน (แปลว่า SAP ลง 101 และ 261 เรียบร้อยแล้ว)
        if (
          checkRes.data?.status === true && 
          latestData && 
          (!targetReel || String(fetchedReel) === String(targetReel))
        ) {
          console.log("✅ พบข้อมูลเอกสาร 101/261 ในระบบเรียบร้อยแล้ว! สลับสถานะเป็น Success");

          dispatch({
            type: actiontype.POST_WEIGHT,
            payload: latestData,
          });

          return {
            success: true,
            data: latestData,
            message: "บันทึกข้อมูลเข้า SAP เรียบร้อยแล้ว",
          };
        }
      } catch (checkErr) {
        console.log("❌ ตรวจสอบข้อมูลย้อนหลังไม่พบ:", checkErr);
      }

      // 🌟 4. ถ้าตรวจสอบแล้วไม่มีข้อมูลจริงๆ ค่อยแจ้งเตือน Error
      return handleApiError(error);
    }
  };

export const getPrintlabel = (materialDoc: any) => async (dispatch: any) => {
  try {
    const { data } = await apiurl.get(apirouter.printlabel + materialDoc);

    if (data.status === true) {
      dispatch({ type: actiontype.GET_PRINTLABEL, payload: data.data });
    } else {
      console.log("error" + data.message);
    }
  } catch (error: any) {
    console.log(handleApiError(error).message);
  }
};

export const postPrintlabel =
  (profile: any, response: any) => async (dispatch: any) => {
    try {
      const { data } = await apiurl.post(apirouter.postprintlabel, {
        product_id: response?.product_id,
        materialdoc: response?.materialdoc?.materialDoc,
        empcode: profile?.EmpCode,
      });

      if (data.status === true) {
        dispatch({ type: actiontype.POST_PRINTLABEL, payload: data.data });
        return { success: true, data: data.data, message: data.message };
      } else {
        return { success: false, message: data.message };
      }
    } catch (error: any) {
      return handleApiError(error);
    }
  };

export const selectedLocation =
  (item: any, scale: any, responseparams: any) => async (dispatch: any) => {
    try {
      const { data } = await apiurl.post(apirouter.selectedlocation, {
        product_id: scale?.product_id,
        reel_no: scale?.reel_no,
        materialdoc: responseparams?.materialdoc?.materialDoc,
        storage_location: item?.storage_location,
        plant: item?.plan,
      });

      if (data.status === true) {
        dispatch({ type: actiontype.SELECTED_LOCATION, payload: data.data });
        return { success: true, data: data.data, message: data.message };
      } else {
        return { success: false, message: data.message };
      }
    } catch (error: any) {
      return handleApiError(error);
    }
  };

export const enterLocation =
  (item: any, scale: any, responseparams: any) => async (dispatch: any) => {
    try {
      const { data } = await apiurl.post(apirouter.enterlocation, {
        product_id: scale?.product_id,
        reel_no: scale?.reel_no,
        scanloc: item?.storage_location,
        materialdoc: responseparams?.materialdoc?.materialDoc,
        empcode: scale?.employee_code,
      });

      if (data.status === true) {
        dispatch({
          type: actiontype.ENTER_LOCATION,
          payload: data.data,
        });
        return {
          success: true,
          data: data.data,
          message: data.data.mov_no,
        };
      } else {
        return { success: false, message: data.data?.mov_no || data.message };
      }
    } catch (error: any) {
      return handleApiError(error);
    }
  };

export const postOrderPrintlabel =
  (profile: any, response: any) => async (dispatch: any) => {
    try {
      const { data } = await apiurl.post(apirouter.postprintlabel, {
        product_id: response?.product_id,
        materialdoc: response?.materialDoc,
        empcode: profile?.EmpCode,
      });

      if (data.status === true) {
        dispatch({ type: actiontype.POST_ORDERPRINTLABEL, payload: data.data });
        return { success: true, data: data.data, message: data.message };
      } else {
        return { success: false, message: data.message };
      }
    } catch (error: any) {
      return handleApiError(error);
    }
  };

export const postWeightWip =
  (item: any, qrData: any) => async (dispatch: any) => {
    try {
      const response = await apiurl.post(apirouter.weightwip, {
        product_id: item?.product_id,
        qrcode: qrData ? qrData : "0",
      });

      if (response.data.status === true) {
        dispatch({
          type: actiontype.POST_WEIGHT_WIP,
          payload: response.data.data,
        });
        return {
          success: true,
          data: response.data.data,
          message: response.data.message,
        };
      } else {
        return {
          success: false,
          message: response.data.message,
        };
      }
    } catch (error: any) {
      return handleApiError(error);
    }
  };

export const postWeightMaster =
  (scale: any, weight: any, profile: any, item: any, postwip: any) =>
  async (dispatch: any) => {
    try {
      const response = await apiurl.post(apirouter.weightmaster, {
        product_id: scale?.product_id,
        reel_no: scale?.reel_no,
        empcode: profile?.EmpCode,
        weight: weight ?? "0",
        meter: item?.meter ? item?.meter : "0",
        weight_location: scale?.weight_location,
        container_id: item?.container_id,
      });

      if (response.data.status === true) {
        dispatch({
          type: actiontype.POST_WEIGHT_MASTER,
          payload: response.data.data,
        });
        return {
          success: true,
          data: response.data.data,
          message: response.data.message,
        };
      } else {
        return {
          success: false,
          message: response.data.message,
        };
      }
    } catch (error: any) {
      return handleApiError(error);
    }
  };

export const postCancelOrder =
  (item: any, item2: any) => async (dispatch: any) => {
    try {
      const response = await apiurl.post(apirouter.cancelorder, {
        product_id: item?.product_id,
        reel_no: item?.reel_no,
        type: "0",
      });

      if (response.data.status === true) {
        dispatch({
          type: actiontype.POST_CANCEL_ORDER,
          payload: response.data.data,
        });
        return {
          success: true,
          data: response.data.data,
          message: response.data.message,
        };
      } else {
        return { success: false, message: response.data.message };
      }
    } catch (error: any) {
      return handleApiError(error);
    }
  };

export const changeMeter =
  (item: any, profile: any) => async (dispatch: any) => {
    try {
      const data = {
        product_id: item?.product_id,
        reel_no: item?.reel_no,
        meter_old: item?.meter ? item?.meter : "0",
        meter: item?.meter_change,
        order_no: item?.order_number,
        machine_code: item?.machine_code,
        container_id: item?.container_id,
        matcode: item?.material_code,
        matname: item?.order_name,
        emp_code: profile?.EmpCode,
        emp_name: profile?.FullName,
      };

      const requestBody = { 
          data: data 
      };

      const response = await axios.post(
        "https://api-master-spl.veninecopper.com/api/v1/master/changeMeter",
        requestBody,
        {
          headers: {
            "x-api-key": apikey,
            "Content-Type": "application/json",
          }
        }
      );

      if (response.data.status === true) {
        dispatch({
          type: actiontype.CHANGE_METER,
          payload: response.data.data,
        });
        return {
          success: true,
          meter_change: item?.meter_change,
          data: response.data.data,
          message: response.data.message,
        };
      } else {
        return { success: false, message: response.data.message };
      }
    } catch (error: any) {
      return handleApiError(error);
    }
  };

export default {
  actiontype,
  postWeight,
  postAcceptOrder,
  getPrintlabel,
  postPrintlabel,
  selectedLocation,
  enterLocation,
  postOrderPrintlabel,
  postWeightWip,
  postWeightMaster,
  postCancelOrder,
  changeMeter,
};